export default "__VITE_ASSET__B0aF0v0y__"